import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { StyledConnectionLogo } from "../../../elements/connection/styledConnection";
import Notification from "../../../elements/notification/Notification";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import RenderStatus from "../../../styles/styledStatus";
import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../../styles/styledTable";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid } from "../../../styles/styledTabsForm";
import { StyledDocumentDetailsContent } from "../../styledDocument";

const DocumentDetailsContent = ({ document }) => {

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  if (!document) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  const {
    id,
    attributes,
    connection,
    createdAt,
    flowData,
    schema,
    processingId,
    status
  } = document;

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledDocumentDetailsContent>
        <StyledFormGrid className="payout-details-content">
          <StyledFormBlock className="payout-details-content__block">
            <StyledBlockLabel>
              Main
            </StyledBlockLabel>
            <StyledTable size="16">
              <StyledTableHead
                col="2"
                className="payout-details-content__head"
              >
                <StyledCol>Ключ:</StyledCol>
                <StyledCol>Значение:</StyledCol>
              </StyledTableHead>
              <StyledTableBody>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Id
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <CopyToClipboard
                      text={id}
                      onCopy={() => {
                        setNotification({ ...notification, visible: true, type: "success", message: "Скопировано" });
                      }}
                    >
                      <StyledBreakWord as="p">
                        {id} <StyledCopy
                        title="Скопировать"
                        className="icon-light-copy"
                      />
                      </StyledBreakWord>
                    </CopyToClipboard>
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Processing id
                  </StyledCol>
                  <StyledCol
                    inline
                    data-title="Значение"
                  >
                    <p>{processingId ?? "-"}</p>
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Статус
                  </StyledCol>
                  <StyledCol
                    inline
                    data-title="Значение"
                  >
                    <RenderStatus status={status.value} />
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Дата и время
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    {TimestampToDateMoment(createdAt)}
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Схема
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <p>{schema.subName}</p>
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    E-Mail
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <p>{attributes[0].value}</p>
                  </StyledCol>
                </StyledTableRow>
              </StyledTableBody>
            </StyledTable>
          </StyledFormBlock>

          <StyledFormBlock className="payout-details-content__block">
            <StyledBlockLabel>
              Connection
            </StyledBlockLabel>
            <StyledTable size="16">
              <StyledTableHead
                col="2"
                className="payout-details-content__head"
              >
                <StyledCol>Ключ:</StyledCol>
                <StyledCol>Значение:</StyledCol>
              </StyledTableHead>
              <StyledTableBody>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Id подключения
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <div>
                      <p>{connection.id}</p>
                    </div>
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Сервис
                  </StyledCol>
                  <StyledCol
                    data-title="Значение"
                    className="service"
                  >
                    <div>
                      <p>{connection.service.name}</p>
                    </div>
                    <StyledConnectionLogo
                      icon={connection.service.name}
                      className="service__icon"
                    />
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Сервис id
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <p>{connection.service.id}</p>
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Проект
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <p>{connection.project.name}</p>
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="payout-details-content__row"
                >
                  <StyledCol data-title="Ключ">
                    Проект id
                  </StyledCol>
                  <StyledCol data-title="Значение">
                    <p>{connection.project.id}</p>
                  </StyledCol>
                </StyledTableRow>
              </StyledTableBody>
            </StyledTable>
          </StyledFormBlock>

          <StyledFormBlock className="payout-details-content__block">
            <StyledBlockLabel>
              Flow data
            </StyledBlockLabel>
            {flowData.length !== 0 ?
              <StyledTable size="16">
                <StyledTableHead
                  col="2"
                  className="payout-details-content__head"
                >
                  <StyledCol>Ключ:</StyledCol>
                  <StyledCol>Значение:</StyledCol>
                </StyledTableHead>
                <StyledTableBody>
                  {flowData.map((dataItem, key) => (
                    <StyledTableRow
                      col="2"
                      key={key}
                      className={`payout-details-content__row ${dataItem.name === "errors" && "errors"}`}
                    >
                      <StyledCol data-title="Ключ">
                        {dataItem.name}
                      </StyledCol>
                      <StyledCol data-title="Значение">
                        <p>
                          {dataItem.value}
                        </p>
                      </StyledCol>
                    </StyledTableRow>
                  ))}
                </StyledTableBody>
              </StyledTable>
              : <Alert severity="info">Информация отсутсвует</Alert>}
          </StyledFormBlock>
        </StyledFormGrid>
      </StyledDocumentDetailsContent>
    </>
  );
};

export default DocumentDetailsContent;